// Me store entryfile
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

// Initial state
const state = {
  config: {},
  statistics: {},
  groupBy: '',
  startDate: '',
  endDate: '',
  dataLoaded: {},
  loaded: false,
  loading: false,
  rights: [],
};

export default {
  actions,
  mutations,
  getters,
  state,
};
